import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";

import { FireDataService } from '../fire-data.service';

@Component({
  selector: 'app-teacher',
  templateUrl: './teacher.component.html',
  styleUrls: ['./teacher.component.css']
})
export class TeacherComponent implements OnInit {

  //snap: Object;
  snap: Array<any>; // two dimensions, contains all schedule cols ad rows
  fillRow: Array<any>; // one dimension, contain fill data to color every cols of snap
  public teacher: string;
  public teacherType: string;

  constructor(private fds: FireDataService, private router: Router, private route: ActivatedRoute, private location: Location) {

    //this.isLogged();
    this.snap = [];
    this.snap[0] = [{text: 'Day', cols: 1, rows: 1, color: 'lightgray'}, {text: 'Couse', cols: 2, rows: 1, color: 'lightgray'},
                    {text: '08:10', cols: 1, rows: 1, color: 'lightgray'},{text: '09:05', cols: 1, rows: 1, color: 'lightgray'},
                    {text: '10:00', cols: 1, rows: 1, color: 'lightgray'},{text: '11:10', cols: 1, rows: 1, color: 'lightgray'},
                    {text: '12:05', cols: 1, rows: 1, color: 'lightgray'},{text: '12:55', cols: 1, rows: 1, color: 'lightgray'},
                    {text: '13:45', cols: 1, rows: 1, color: '#afb8cc'},{text: '14:35', cols: 1, rows: 1, color: '#afb8cc'},
                    {text: '15:25', cols: 1, rows: 1, color: '#afb8cc'},{text: '16:15', cols: 1, rows: 1, color: '#afb8cc'}];
    
    this.fillRow = [];
  
    this.fillRow.length = 12;
    this.fillRow = Array.from(this.fillRow, function(val, idx){return {text: ' ', cols: 1, rows: 1, color: '#E3F2FD'}} );
    this.fillRow[1].cols = 2;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
        this.teacher = params["teacher"];
        this.teacherType = params["type"];
        for (var i = this.snap.length; i > 1; i--) {
            this.snap.pop();
        }
        if (this.teacher) {
        var pp = this.snap;
        this.fds.readTeacher(this.teacherType, this.teacher, this.snap, this.fillRow, '#90CAF9', '#90CAF9', '#BBDEFB')
            .then(function(res){
                 Object.keys(res).map(key => pp.push(res[key]));
            });
        }
    });
  }

  private isLogged() {
    this.fds.user.subscribe(res => {
      if (res) {
        return
      }
      if (!res) {
        this.router.navigate(["/login"]);
      }
    });
  }

  public goBack() {
    this.location.back();

  }

}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/teacher/teacher.component.ts